import { type ComponentProps } from 'react';

import { cn } from '@/lib/utils/cn';

export function Label({ className, ...props }: ComponentProps<'label'>) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- association is provided by consumers via htmlFor
    <label
      className={cn('text-sm leading-none font-medium text-foreground', className)}
      {...props}
    />
  );
}
